import { Dialog, DialogContent, Box, Typography, DialogActions, FormHelperText, Button, TextField, Alert } from '@mui/material';
import { setSuccessfullModifyDialog } from '../../../redux/successfullModifyDialogSlice';
import { setEquipmentDetailsData } from '../../../redux/equipmentDetailsDataSlice';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Iconify from '../../Iconify';
import { useFormik } from 'formik';
import { useState } from 'react';
import * as Yup from 'yup';
import axios from 'axios';
import '../../../css/roles/updateRoleName.css';

export const UpdateEquipment = ({ updateEquipmentOpen, setUpdateEquipmentOpen }) => {

    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [errMsg, setErrMsg] = useState(null);
    const equipmentDetailsData = useSelector((state) => state.EquipmentDetailsData);

    const formik = useFormik({
        initialValues: {
            name: equipmentDetailsData?.name || '',
            description: equipmentDetailsData?.description || '',
        },
        validationSchema: Yup.object().shape({
            name: Yup.string().required(t('isRequired')),
            description: Yup.string().optional(),
        }),
        onSubmit: async (values) => {
            try {
                const response = await axios.patch(`equipment/${equipmentDetailsData.id}`, values);
                if (response.status === 200 || response.status === 201) {
                    dispatch(setEquipmentDetailsData({ ...equipmentDetailsData, name: response.data.name, description: response.data.description }));
                    dispatch(setSuccessfullModifyDialog({ open: true, type: "Modifier le nom et la description de l'équipement" }));
                    setUpdateEquipmentOpen(false);
                }
            } catch (error) {
                setErrMsg(error?.response?.data?.message || error.message || 'Erreur lors de la modification de l\'équipement');
                console.error('Error updating équipement :', error);
            }
        },
    });

    const { handleSubmit, values, handleChange, handleBlur, touched, errors } = formik;

    return (
        <Dialog open={updateEquipmentOpen} fullWidth>
            <Box onClick={() => setUpdateEquipmentOpen(false)} className='updateRoleName_icon_text'>
                <Typography className='updateRoleName_title'>{t("Modifier le nom et la description de l'équipement")}</Typography>
                <Iconify icon={"material-symbols:close"} className='updateRoleName_close_icon' />
            </Box>
            {errMsg && <Alert key={errMsg} severity="error">{errMsg}</Alert>}
            <form onSubmit={handleSubmit}>
                <DialogContent className='updateRoleName_dialog_content'>
                    <Box className="updateRoleName_helper_selct_box">
                        <FormHelperText id="outlined-weight-helper-text" className="updateRoleNameInputTitle">{t('Nom')}</FormHelperText>
                        <TextField
                            fullWidth
                            value={values.name}
                            className='updateRoleName_InputField'
                            id="outlined-adornment-weight"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="name"
                            error={touched.name && Boolean(errors.name)}
                            helperText={touched.name && errors.name}
                            aria-describedby="outlined-weight-helper-text"
                        />
                    </Box>
                    <Box className="updateRoleName_helper_selct_box">
                        <FormHelperText id="outlined-weight-helper-text" className="updateRoleNameInputTitle">{t('Description')} (optionnel)</FormHelperText>
                        <TextField
                            fullWidth
                            value={values.description}
                            className='updateRoleName_InputField'
                            id="outlined-adornment-weight"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="description"
                            error={touched.description && Boolean(errors.description)}
                            helperText={touched.description && errors.description}
                            aria-describedby="outlined-weight-helper-text"
                        />
                    </Box>
                </DialogContent>
                <DialogActions className='updateRoleName_dialog_actions'>
                    <Button className='updateRoleName_button_annuler' onClick={() => setUpdateEquipmentOpen(false)}>{t('Annuler')}</Button>
                    <Button className='updateRoleName_button_valider' variant="contained" type="submit">{t('Valider')}</Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};